// ** React Imports
import { Fragment } from "react";

// ** MUI Imports
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const UnsavedChangesDialog = ({ open, handleClose, handleDiscard }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: '400px',
          height: '85vh',
          maxHeight: '200px',
          minHeight: '100px',
          borderRadius: '8px',
          overflow: 'hidden',
          position: 'relative' // Needed for absolute positioning of close icon
        }
      }}
    >
      {/* Close Icon */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          color: 'grey.500',
          zIndex: 1
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ 
        py: 4,
        px: 4,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        flexGrow: 1
      }}>
        <Typography 
          variant="h5" 
          fontWeight="bold" 
          gutterBottom 
          sx={{ 
            fontSize: '1.5rem',
            mb: 2
          }}
        >
          Are you sure?
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ fontSize: "1rem", mb: 0 }}
        >
          This page has some unsaved changes
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "16px 24px",
          '& .MuiButton-root': {
            borderRadius: '4px',
            textTransform: 'none',
            fontWeight: '500',
            padding: '8px 16px',
            minWidth: '120px',
            fontSize: '0.875rem'
          }
        }}
      >
        <Button 
          variant="contained" 
          color="main" 
          onClick={handleDiscard}
          sx={{
            bgcolor: 'main', 
            '&:hover': {
              bgcolor: 'main',
            }
          }}
        >
          Yes, discard changes
        </Button>
        <Button 
          variant="outlined" 
          onClick={handleClose}
          sx={{
            color: '#5E5E5E',
            borderColor: '#E0E0E0',
            marginLeft: '10px',
            '&:hover': {
              borderColor: '#E0E0E0',
              backgroundColor: '#F5F5F5'
            }
          }}
        >
          No, stay here
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
